const accessUrl: Record<string, string> = {
  prod: `https://access.alta.avigilon.com/`,
  prodeu1: `https://access.eu.alta.avigilon.com/`,
  dev: 'https://platinum.dev.alta.avigilon.com/',
  sandbox: 'https://platinum.sandbox.alta.avigilon.com/',
  mine: `http://localhost:3000/`,
};

export const getAccessUrl = (region: string): string => {
  return accessUrl[region];
};
